<template>
    <div id="news">
        <div class="box">
            <h1 id="title" class="title"><img src="/static/img/transparent.png" class="logo is-paddingless"> {{ singleNews.title }} </h1>
            <p class="subtitle">{{singleNews.description}}</p>
        </div>
        <!--<hr>-->
        <!--<div class="container">-->
            <div class="columns box is-multiline">
                <div class="column">
                    <div class="content" v-html="singleNews.text">

                    </div>
                </div>
            </div>
        <!--</div>-->

    </div>
</template>
<script>
import Vue from 'vue'
import UserRepo from '../repos/UserRepo'
import NewsRepo from '../repos/NewsRepo'
import global from '../mixins/globalMixins'

import _ from 'lodash'

export default {
  name: 'single-news',
  components: {},
  mixins : [global],
  data() {
        return {
            loading: false,
            repo: new NewsRepo(this.$auth),
            userRepo: new UserRepo(this.$auth),
            singleNews:{},
            user: {},
        }
  },
  created(){
        this.loadUser();
        this.loadSingleNews(this.$route.params.id);


  },
  mounted(){

  },
  methods: {

        loadUser(){
            this.userRepo.me().then(response => {
                this.user = response.data.data;
                this.buy();
            });
        },
        buy(){
            let url_string = window.location.href;
            let url = new URL(url_string);
            let buy = url.searchParams.get("buy");

            if(this.user && this.user.email && buy) {
                let self = this;

                Paddle.Checkout.open({
                    product: buy,

                    passthrough: this.user.email,
                    //email: this.user.email,
                    successCallback: function () {
                        self.$swal(
                            'Congratulations!',
                            'Thank you for purchasing Sammy\'s Sponsor Bundle! 12-month subscription time will be added to your account and our Admin Team will contact you for your T-shirt preference and shipping address.',
                            'success'
                        ).then((result) => {
                            self.$router.push('/dashboard/comments');
                        });
                    }
                }, false);
            }
        },
        loadSingleNews(id){
            this.loading = true;
            this.repo.updateSeen(id).then(response => {
                this.singleNews = response.data.data;
                this.$parent.removeNews(id);
                this.loading = false;
            }).catch((response) => {
                this.loading = false;
                return Promise.reject(response);
            });
        },
  },  
  watch: {
      'student.name':_.debounce(function(value){
          if(value.length >= 3){
          }
          else if(value == ''){
          }

      }, 800),
      '$route.params.id'(newId, oldId) {
          this.loadSingleNews(newId);
      }
    
  }
  
}

</script>

<style lang="css" scoped>


@keyframes click-wave {
  0% {
    height: 20px;
    width: 20px;
    opacity: 0.35;
    position: relative;
  }
  100% {
    height: 30px;
    width: 30px;
    margin-left: -5px;
    margin-top: -5px;
    opacity: 0;
  }
}

.logo{
    height: 48px !important;
    width: auto !important;
    margin-bottom: -14px;
    margin-right: 10px;
}

.option-input {
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  -o-appearance: none;
  appearance: none;
  position: relative;
  top: 4.33333px;
  right: 0;
  bottom: 0;
  left: 0;
  height: 20px;
  width: 20px;
  transition: all 0.15s ease-out 0s;
  background: #cbd1d8;
  border: none;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  margin-right: 0.5rem;
  margin-left: 0.5rem;
  outline: none;
  position: relative;
  z-index: 11;
}
.option-input:hover {
  background: #9faab7;
}
.option-input:checked {
  background: #00d1b2!important;
}
.option-input:checked::before {
  height: 20px;
  width: 20px;
  position: absolute;
  content: '✔';
  display: inline-block;
  font-size: 13.3333px;
  text-align: center;
  line-height: 20px;
}
.option-input:checked::after {
  -webkit-animation: click-wave 0.65s;
  -moz-animation: click-wave 0.65s;
  animation: click-wave 0.65s;
  background: #00d1b2!important;
  content: '';
  display: block;
  position: relative;
  z-index: 10;
}
.option-input.radio {
  border-radius: 50%;
}
.option-input.radio::after {
  border-radius: 50%;
}
.option-input span {
    padding-top: 10px;
}

.draggable{
    min-height: 70px;
}

.card-content{
    padding-top:2px;
    padding-bottom:2px;
}

.max-height-250{
    height: 250px;
    max-height: 250px;    
    overflow-y: auto; 
}

.height-auto{
    height:auto;
}

.height-min-content{
    height: min-content;
}

.clear-star{
    margin-top: 7px;
    margin-left: 5px;
}

.float-left{
    float: left;
}

.display-block{
    display: block;
}

.sentence-font-size{
    font-size: 0.95rem !important;
}

.height-100{
    height: 100px;
}

.editor{
    min-height: 300px;
    overflow: auto;    
    font-size: 14px;
    line-height: 1.5;
    background-color: #fff;
    color: #333;    
    overflow: hidden;
    text-align: justify;    
    font-family: 'Pfdintextpro';
    white-space: pre-line !important;
    border:none;
    width: 100% !important;
    max-width: 100% !important;
    padding: 0px;
}

.editor:active, .editor:focus{
    border:none;     
    outline:none;
}
.editor-pre{
    border: 1px solid #ddd;
    text-align: left;
    border-radius: 5px;
    padding: 10px;   
    min-height: 300px;
    font-size: 14px;
    line-height: 1.5;
    background-color:transparent;    
}

.ctx-menu.ctx-menu-left li{
    padding-left: 10px;
    line-height: 24px;
}

.ctx-menu.ctx-menu-left li:hover{
    cursor: pointer;
    color: white;
    background-color: #00d1b2;
}

.ctx-menu.ctx-menu-left li span{
    padding-left: 5px;
}

.title{
    margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/SingleNews.vue